// extracted by mini-css-extract-plugin
export default {"graphMenu":"ChartSelector_graphMenu__p51lq","graphLink":"ChartSelector_graphLink__q5HhZ","dataTitle":"ChartSelector_dataTitle__k3uga"};